
import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/skeleton';
import { Separator } from '@/components/ui/separator';

const BrowseLoadingState: React.FC = () => {
  const { resolvedTheme } = useTheme();
  const bgColor = resolvedTheme === 'dark' ? 'bg-netflix-black' : 'bg-background';
  
  return (
    <div className={cn("min-h-screen", bgColor)}>
      <div className="article-container py-8">
        <Skeleton className="h-12 w-1/3 mb-8" />
        <div className="flex flex-col md:flex-row gap-8">
          <div className="w-full md:w-64 shrink-0">
            <Skeleton className="h-8 w-32 mb-4" />
            <div className="space-y-2">
              {[1, 2, 3, 4, 5].map(i => <Skeleton key={i} className="h-10 w-full" />)}
            </div>
          </div>
          <Separator orientation="vertical" className="hidden md:block h-auto" />
          <div className="flex-1">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3, 4, 5, 6].map(i => <Skeleton key={i} className="h-80 w-full" />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrowseLoadingState;
